import { render, staticRenderFns } from "./form-file-translation.vue?vue&type=template&id=413b8544&scoped=true"
import script from "./form-file-translation.ts?vue&type=script&lang=ts&external"
export * from "./form-file-translation.ts?vue&type=script&lang=ts&external"
import style0 from "./form-file-translation.vue?vue&type=style&index=0&id=413b8544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b8544",
  null
  
)

export default component.exports